import { IWorkbookPayoutSchedule } from 'app/redux/SSA/actions'
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import { ISSAMonthPayoutDetails } from './Optimize/index'

function groupSamePayments(whens: ISSAMonthPayoutDetails[]) {
  const r: string[] = []
  let startSeq: ISSAMonthPayoutDetails
  let endSeq: ISSAMonthPayoutDetails
  let lookFor: number

  const capture = () => {
    if (!startSeq) { return }
    let item = startSeq.m
    if (startSeq !== endSeq) {
      item += '-' + endSeq.m
    }
    r.push(item + ': ' + utils.toCurrency(startSeq.a))
  }

  _.forEach(whens, (e) => {
    if (e.a === lookFor) {
      endSeq = e
    } else {
      capture()
      startSeq = endSeq = e
      lookFor = e.a
    }
  })

  capture()
  return r
}

function monthlyYAxisLabeller() {
  return utils.toCurrency(this.value)
}

function yAxisLabeller() {
  return utils.toCurrency(this.value, false)
}

function monthlyPointFormatter() {
  const paymentGroups = groupSamePayments(this.point.data)
  if (paymentGroups.length <= 1) {
    return 'Monthly benefit for ' + this.series.name
      + '<br/> in ' + this.x + ' is ' + utils.toCurrency(this.y)
  } else {
    const details = _.map(paymentGroups, (item: any, index: number) => {
      const spacer = (0 === index % 3) ? '<br/>' : ', '
      return spacer + item
    })
    return 'SSA benefit amounts for ' + this.series.name
      + '<br/>differ in ' + this.x + '. The average is ' + utils.toCurrency(this.y) + '.<br/>'
      + details.join('')
  }
}

function pointFormatter() {
  return 'Accumulated lifetime benefit for ' + this.series.name + ' in ' + this.x + ' is ' + utils.toCurrency(this.y, false)
}

const lifetimeBenefitsChartConfig = {
  colors: ['#8dc248', '#26a69a', '#23282d', '#e51c23', '#8dc248', '#64E572',
    '#FF9655', '#FFF263', '#6AF9C4'],
  chart: {
    type: 'line',
    height: 300
  },

  credits: {
    enabled: false
  },

  title: {
    text: ''
  },

  xAxis: {
    max: 2040
  },

  yAxis: {
    labels: {
      formatter: yAxisLabeller
    },
    title: {
      text: 'Lifetime Benefit'
    }
  },
  legend: {
    enabled: true
  },

  tooltip: {
    formatter: pointFormatter
  },

  plotOptions: {
    series: {
      pointStart: 2017
    }
  },

  series: []
}

const monthlyBenefitChartConfig = {
  chart: {
    type: 'line',
    height: 300
  },

  credits: {
    enabled: false
  },

  title: {
    text: ''
  },

  xAxis: {
    max: 2040
  },

  yAxis: {
    labels: {
      formatter: monthlyYAxisLabeller
    },
    title: {
      text: 'Monthly Benefit'
    }
  },
  legend: {
    enabled: true
  },

  tooltip: {
    formatter: monthlyPointFormatter,
    useHTML: true
  },

  plotOptions: {
    series: {
      pointStart: 2017
    }
  },

  series: []
}

export {
  lifetimeBenefitsChartConfig,
  monthlyBenefitChartConfig
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/SSA/chart.ts